import React, { useState } from "react";
import Sidemenu from "./Sidemenu";
import style from './env.module.sass';
import View from "./View";
import NoData from '../../apps/NoData'
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'

export const defaultApiKey = 'xxxxxxxxxxxxxxxxxxxxxxxxxx';

const Environment: React.FC = () => {

    const [isForbidden, setIsForbidden] = useState(false)
    const [loadingSpin, setLoadingSpin] = useState(true)

    return (
        !isForbidden ?
        <div  className={"row " + style.view}>
            <div className={style.first}>
                <Sidemenu setIsForbidden={setIsForbidden} setLoadingSpin={setLoadingSpin}/>
            </div>
            <div className={style.second}>
                  <View loadingSpin={loadingSpin} />
            </div>
        </div>
        :
        <NoData 
            svg={WarningIcon}
            header='Not Authorized'
            content='Please request owner of this organization to provide access' 
            noButton={true}
        />
    )
}

export default Environment;